module.exports = __webpack_public_path__ + "static/lottery-button-disable.a6e91c20.png";